var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 39,
    viewBox: "0 0 33 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5267 0.809514C22.5833 1.79884 28.1986 6.1867 30.5528 10.9868C34.1529 18.3243 32.8063 26.6603 27.0994 32.3764C22.9314 36.5536 17.0503 38.688 11.9205 37.8727C7.23951 37.1307 3.7219 33.8146 5.80132 32.0924C6.29598 31.6802 6.83645 31.8176 9.1174 32.926C12.6533 34.6482 15.5022 34.7123 18.7817 33.1642C21.4016 31.9275 24.452 28.8313 25.9268 25.9183C28.5192 20.7884 27.0627 13.9822 22.4733 9.74095C20.284 7.71649 18.855 7.01114 15.6488 6.35158C12.6625 5.74699 10.0976 6.04929 7.61509 7.32259C1.86233 10.2631 1.72492 18.0403 7.3586 21.9243C9.14488 23.1518 9.72199 23.3442 11.5999 23.3167C14.1465 23.2801 14.9984 22.6938 16.116 20.2113C17.1145 17.9945 16.803 16.767 15.0625 16.0342C13.4411 15.3471 12.7358 15.6403 11.2518 17.5915C9.25481 20.2113 7.92654 18.9197 9.08076 15.4937C10.0884 12.5074 11.6182 11.2158 14.1373 11.2158C16.3542 11.2158 17.7099 11.8112 19.2031 13.4326C20.6779 15.0265 21.0718 15.9792 21.0718 17.8937C21.0718 20.0281 19.4595 23.3442 17.829 24.5717C17.1603 25.0755 15.6488 25.7626 14.4763 26.1015C11.9297 26.8343 8.60442 26.4404 6.55248 25.1671C5.00436 24.2053 2.77837 21.7961 1.94477 20.1747C0.955444 18.2602 0.0943617 13.8906 0.341694 12.0219C1.09285 6.31494 5.83796 1.82632 12.1862 0.800354C14.9892 0.351492 15.1908 0.351492 17.5267 0.809514Z",
    fill: "#008AE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2631,
    height: 37.5853,
    fill: "white",
    transform: "translate(0.287109 0.460938)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/vector-8.1ffd63e7eb6cafa92875fda0726a05c8.svg";
export { ForwardRef as ReactComponent };